var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pr-8",
    attrs: {
      "cols": "3",
      "md": "2"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.phone1,
      callback: function callback($$v) {
        _vm.phone1 = $$v;
      },
      expression: "phone1"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs, {
    label: _vm.label,
    readonly: _vm.readonly,
    dense: _vm.dense
  }), false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.phone2,
      callback: function callback($$v) {
        _vm.phone2 = $$v;
      },
      expression: "phone2"
    }
  }, 'v-text-field', Object.assign({}, _vm.$attrs, {
    readonly: _vm.readonly,
    dense: _vm.dense
  }), false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }